import { createContext, useContext } from "react";

type RadioContainerGroupContextValue = {
  isError: boolean;
  groupName?: string;
};

export const RadioContainerGroupContext = createContext<RadioContainerGroupContextValue>({
  isError: false,
  groupName: undefined,
});

export const useRadioContainerGroupContext = () => useContext(RadioContainerGroupContext);
